import { useAuth } from "@/components/Auth";
import { base64ToUtf8 } from "@/lib/helpers/encoding";
import { Alert, Button, Stack, Text, TextInput } from "@mantine/core";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";

export type ResetPasswordParams = {
    UserId: number;
    Token: string;
    Email: string;
    newPassword?: string;
    confirmPassword?: string;
}

const ResetPassword = () => {
    const { code } = useParams();
    const { resetPassword } = useAuth();
    const [params, setParams] = useState<ResetPasswordParams | null>(null);
    const [error, setError] = useState<string | null>(null);
    const navigate = useNavigate();
    useEffect(() => {
        if(code){
            const stringifiedParams = base64ToUtf8(code as string);
            setParams(JSON.parse(stringifiedParams) as ResetPasswordParams);
        }
    }, [code])
    useEffect(() => {
        document.title = "Reset Password - Guard Dog Real Estate Protection Service";
    }, []);
    const handleResetPassword = async () => {
        try {
            if(!params){
                setError("Invalid reset parameters.");
                return;
            }
            if(params.newPassword !== params.confirmPassword){
                setError("Passwords do not match.");
                return;
            }
            if(params.newPassword && params.confirmPassword){
                setError(null);
                const success = await resetPassword({
                    userId: params.UserId,
                    token: params.Token,
                    email: params.Email,
                    newPassword: params.newPassword!,
                    confirmPassword: params.confirmPassword!,
                });
                if(!success){
                    setError("Failed to reset password. Please try again.");
                }else{
                    navigate('/');
                }
            }
        } catch (error) {
            console.error("Error resetting password:", error);
            setError("Failed to reset password. Please try again.");
        }
    }
    return (
       <Stack>
            {error && <Alert title="Error" color="red">{error}</Alert>}

            <Text>Email: {params?.Email}</Text>
            <TextInput label="New Password" type="password" value={params?.newPassword} onChange={(e) => {
                if(params){
                    setParams({...params, newPassword: e.target.value});
                }
            }} />
            <TextInput label="Confirm Password" type="password" value={params?.confirmPassword} onChange={(e) => {
                if(params){
                    setParams({...params, confirmPassword: e.target.value});
                }
            }} /> 
            <Button onClick={handleResetPassword}>
                Reset Password
            </Button>
        </Stack>
    )
}
export default ResetPassword;